import { proxyCustomElement, HTMLElement, h, Host } from '@stencil/core/internal/client';
import './index2.js';
import { D as DomService } from './index3.js';

const rocheBreadcrumbsCss = ":host{display:block;margin-top:3rem;display:flex;justify-content:left;align-items:flex-end;flex-wrap:nowrap;overflow-x:auto;overflow-y:hidden;position:relative;height:5rem;padding:0 0 1rem 0;font-family:\"roche-sans\";font-style:normal;font-weight:200;font-weight:400;font-size:var(--label--font-size--small-up);line-height:1.3125rem;color:#544f4f;white-space:nowrap;mask-image:linear-gradient(to left, transparent 0%, black 2.125rem);-webkit-mask-image:linear-gradient(to left, transparent 0%, black 2.125rem)}@media (min-width: 90rem){:host{margin-top:4.5rem}}:host,:host *{box-sizing:border-box}@media (min-width: 48rem){:host{font-size:var(--label--font-size--medium-up);line-height:1.3125rem}}@media (min-width: 48rem){:host{overflow:hidden;height:6rem;padding:0 0 1.5rem 0}}@media (min-width: 90rem){:host{height:8rem;padding:0 0 2rem 0}}@media print{:host{opacity:0}}:host([dir=rtl]){justify-content:right;mask-image:linear-gradient(to right, transparent 0%, black 2.125rem);-webkit-mask-image:linear-gradient(to right, transparent 0%, black 2.125rem)}";
const RocheBreadcrumbsStyle0 = rocheBreadcrumbsCss;

const RocheBreadcrumbs$1 = /*@__PURE__*/ proxyCustomElement(class RocheBreadcrumbs extends HTMLElement {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
    }
    componentDidLoad() {
        DomService.handleTextDirection(this.element);
    }
    componentDidRender() {
        Array.from(this.element.children).forEach((element, index) => {
            element.setAttribute('data-label', 'Breadcrumb');
            element.setAttribute('data-value', `${index + 1}`);
        });
    }
    // eslint-disable-next-line class-methods-use-this
    render() {
        return (h(Host, { key: '8727b97774a58c3284791acfe4606eb0d1c6667e', "aria-label": "Breadcrumb" }, h("slot", { key: '40f39ae9f7144a0548a329d2a824c60748c68ce9' })));
    }
    get element() { return this; }
    static get style() { return RocheBreadcrumbsStyle0; }
}, [1, "roche-breadcrumbs"]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["roche-breadcrumbs"];
    components.forEach(tagName => { switch (tagName) {
        case "roche-breadcrumbs":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, RocheBreadcrumbs$1);
            }
            break;
    } });
}

const RocheBreadcrumbs = RocheBreadcrumbs$1;
const defineCustomElement = defineCustomElement$1;

export { RocheBreadcrumbs, defineCustomElement };

//# sourceMappingURL=roche-breadcrumbs.js.map